<template>
  <q-card
    v-if="loading == false"
    bordered
    class="q-pa-md shadow-1"
    style="width: 540px; max-width: 95vw"
  >
    <q-card-section class="row text-green-vito no-wrap justify-between">
      <div class="text-h5">
        {{
          type == "filter" ? $t("title.filterOrders") : $t("title.exportOrders")
        }}
      </div>
      <q-btn icon="close" flat round dense v-close-popup />
    </q-card-section>

    <q-card-section v-if="type != 'filter'">
      <div class="text-green-vito text-italic q-mb-xs">
        {{ $t("label.selectExport") }}
      </div>
      <q-select
        filled
        :options="reportsOptions"
        v-model="report"
        @update:model-value="reportSelected()"
        stack-label
        map-options
        emit-value
        :label="$t('label.reportFilter')"
      >
      </q-select>
    </q-card-section>

    <q-card-section v-if="selectStore">
      <div class="text-green-vito text-italic q-mb-xs">
        {{ $t("label.selectStores") }}
      </div>
      <q-btn-toggle
        v-model="allStoresFilter"
        toggle-color="green-vito"
        :options="storesSelectionToggle"
        class="q-mb-sm"
      />
      <q-select
        v-if="!allStoresFilter"
        filled
        v-model="stores"
        multiple
        :options="storeOptions"
        use-chips
        stack-label
        map-options
        emit-value
        :label="$t('label.storeFilter')"
      >
        <template v-slot:prepend>
          <q-icon name="apps" />
        </template>
        <template v-slot:selected>
          <div class="q-gutter-xs q-pt-sm">
            <q-chip
              v-for="(store, index) in stores"
              :key="index"
              removable
              @remove="removeStore(index)"
              color="green-vito"
              text-color="white"
            >
              {{ storeName(store) }}
            </q-chip>
          </div>
        </template>
      </q-select>
    </q-card-section>

    <q-card-section>
      <div class="text-green-vito text-italic q-mb-xs">
        {{ $t("label.selectDates") }}
      </div>
      <q-btn-toggle
        v-model="dateRangeSelection"
        toggle-color="green-vito"
        :options="dateRangeOptions"
        class="q-mb-sm"
        @update:model-value="setDateRange"
      />
      <q-date
        v-model="dateRange"
        range
        :landscape="$q.screen.width > 500"
        color="green-vito"
        ref="dateRangeSelector"
      />
    </q-card-section>

    <q-card-section v-if="selectStatus">
      <div class="text-green-vito text-italic q-mb-xs">
        {{ $t("label.selectStatus") }}
      </div>
      <div class="q-gutter-x-md">
        <q-toggle
          v-for="status of orderStatusOptions"
          :key="status"
          :label="$t('status.' + status)"
          v-model="orderStatus"
          :color="statusColor(status)"
          :val="status"
        />
      </div>
    </q-card-section>

    <q-card-actions class="q-pa-md justify-end">
      <q-btn
        unelevated
        size="md"
        class="text-green-vito"
        :label="$t('button.cancel')"
        v-close-popup
      />
      <q-btn
        unelevated
        size="md"
        class="bg-green-vito text-white"
        :label="type == 'filter' ? $t('button.filter') : $t('button.export')"
        @click="handleFilter"
        :disable="isValidFilter()"
      />
    </q-card-actions>
  </q-card>
</template>

<script>
import StoreApi from "../../apis/Store";
import { OrderStatus } from "./order.enum";
export default {
  props: ["type"],
  emits: ["filter"],
  data: () => {
    let filters = localStorage.orderFilter
      ? JSON.parse(localStorage.orderFilter)
      : { orderStatus: ["complete"], dateRange: null, stores: [] };
    return {
      loading: true,
      stores: filters.stores,
      report: "orders",
      selectStore: true,
      selectStatus: true,
      startDate: null,
      endDate: null,
      storeOptions: [],
      allStoresFilter: filters.stores.length == 0,
      dateRange: filters.dateRange,
      dateRangeSelection:
        filters.dateRange == null ? "previousMonth" : "selection",
      orderStatus: filters.orderStatus,
      orderStatusOptions: ["complete", "canceled", "aborted", "new"],
      reportsOptions: [
        { value: "orders", label: "Liste des ventes" },
        { value: "volumes", label: "Rapport des volumes" },
        { value: "financial", label: "Rapport financier" },
        { value: "kpi", label: "Export KPI" },
      ],
    };
  },
  async mounted() {
    const storeResponse = await StoreApi.findAll();
    storeResponse.data.forEach((store) => {
      this.storeOptions.push({
        label: store.name,
        value: store.id,
      });
    });
    if (this.dateRange == null) this.setDateRange(this.dateRangeSelection);
    this.loading = false;
  },

  methods: {
    setDateRange(rangeSelection) {
      let from = null;
      let to = null;
      switch (rangeSelection) {
        case "previousMonth":
          from = this.$moment()
            .subtract(1, "months")
            .startOf("month")
            .format("YYYY/MM/DD");
          to = this.$moment()
            .subtract(1, "months")
            .endOf("month")
            .format("YYYY/MM/DD");
          this.dateRange = { from, to };
          //console.log(from, to);
          break;
        case "currentMonth":
          from = this.$moment().startOf("month").format("YYYY/MM/DD");
          to = this.$moment().endOf("month").format("YYYY/MM/DD");
          this.dateRange = { from, to };
          //console.log(from, to);
          break;
        default:
          this.dateRange = this.$moment().format("YYYY/MM/DD");
      }
    },

    handleFilter() {
      //console.log(this.dateRange);
      this.$emit("filter", {
        stores: this.stores,
        dateRange: this.dateRange,
        orderStatus: this.orderStatus,
        report: this.report,
      });
    },
    reportSelected() {
      if (this.report == "kpi") {
        this.selectStatus = false;
        this.selectStore = false;
      } else {
        this.selectStatus = true;
        this.selectStore = true;
      }
    },

    removeStore(index) {
      this.stores.splice(index, 1);
    },
    storeName(storeId) {
      const store = this.storeOptions.find((s) => s.value == storeId);
      return store.label;
    },
    statusColor(status) {
      return OrderStatus[status] ? OrderStatus[status].color : "primary";
    },

    isValidFilter() {
      return (
        (!this.allStoresFilter && this.stores.length == 0) ||
        this.orderStatus.length == 0 ||
        this.dateRange == null
      );
    },
  },
  computed: {
    storesSelectionToggle() {
      return [
        { label: this.$t("label.all"), value: true },
        { label: this.$t("label.selection"), value: false },
      ];
    },
    dateRangeOptions() {
      return [
        { label: this.$t("label.previousMonth"), value: "previousMonth" },
        { label: this.$t("label.currentMonth"), value: "currentMonth" },
        { label: this.$t("label.selection"), value: "selection" },
      ];
    },
  },
};
</script>
